module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-medium-circle.c796ae96b97e7e83a1451c8f277544b5.svg";